import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import DropzoneCover from '@/components/share/dropzone_cover'
import DropzoneAttachment from '@/components/share/dropzone_attachment'
import DropzoneProblem from '@/components/share/dropzone_problem'
import DropzoneTemplate from '@/components/share/dropzone_template'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions'

export default {
  name: 'edit',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    DropzoneCover,
    DropzoneAttachment,
    DropzoneProblem,
    DropzoneTemplate,
    EditorContent,
    EditorMenuBar
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    smartthon () {
      return this.$store.getters.smartthon
    },
    env () {
      return this.$store.getters.env
    },
    titleState () {
      return this.title['0'].length < 50 && this.title['0'].length > 0
    },
    coverState () {
      return this.smartthon.isCover || this.isUpload
    },
    bizTitleState () {
      return this.bizTitle['0'].length < 50 && this.bizTitle['0'].length > 0
    },
    bizDescriptionState () {
      return this.bizDescription.length > 0 && this.bizDescription !== '<p><br></p>' && this.bizDescription !== '<h1></h1>'
    },
    prbDescriptionState () {
      return this.prbDescription.length > 0 && this.prbDescription !== '<p><br></p>' && this.prbDescription !== '<h1></h1>'
    },
    tmpDescriptionState () {
      return this.tmpDescription.length > 0 && this.tmpDescription !== '<p><br></p>' && this.tmpDescription !== '<h1></h1>'
    },
    criteriaState () {
      return this.criteria['0'].length === 5 &&
        this.criteria['0'][0].length &&
        this.criteria['0'][1].length &&
        this.criteria['0'][2].length &&
        this.criteria['0'][3].length &&
        this.criteria['0'][4].length
    },
    gradersState () {
      return this.graders > 0
    },
    limitCaseState () {
      return this.awards.limitCase > 0
    },
    prizeState () {
      return this.awards.prize >= 3
    },
    limitDateState () {
      return this.awards.limitDate
    },
    ceremonyState () {
      return this.awards.ceremony.length > 0 && this.awards.ceremony.length <= 50
    },
    phase2TitleState () {
      return this.awards.phase2.title.length > 0 && this.awards.phase2.title.length <= 50
    },
    publishState () {
      return this.titleState &&
             this.coverState &&
             this.bizTitleState &&
             this.bizDescriptionState &&
             this.prbDescriptionState &&
             this.tmpDescriptionState &&
             this.criteriaState &&
             this.gradersState &&
             this.limitCaseState &&
             this.prizeState &&
             this.limitDateState &&
             this.ceremonyState
    }
  },
  data () {
    return {
      alert: {
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: ''
      },
      sidebar_tab: '2',
      loading: true,
      updating: {
        draft: false,
        publish: false
      },
      titleIndex: 0,
      bizIndex: 0,
      bizDescriptionIndex: 0,
      prbDescriptionIndex: 0,
      tmpDescriptionIndex: 0,
      criteriaIndex: 0,
      phase2Index: 0,
      ceremonyIndex: 0,
      title: {
        '0': '',
        '1': '家庭教師C2Cプラットフォームサービスの利用者を増やす施策を考えてください',
        '2': '準備中',
        '3': '準備中'
      },
      preview: `${process.env.DOMAIN}/preview/${this.$store.getters.user.enterpriseId}/${this.$route.params.smartthonId}`,
      isCopied: false,
      isUpload: false,
      coverId: '',
      bizTitle: {
        '0': '',
        '1': '東大・東工大・一橋大の学生限定の家庭教師C2Cプラットフォームを運営しています',
        '2': '準備中',
        '3': '準備中'
      },
      bizDescription: '',
      bizEditor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: '事業内容を入力しましょう！',
        onUpdate: ({ getJSON, getHTML }) => {
          this.bizDescription = getHTML().replace(/<p><\/p>/g, '<p><br></p>')
        }
      }),
      bizAttachment: {
        isUpload: false,
        isComplete: false,
        isError: false,
        name: undefined,
        id: undefined
      },
      prbDescription: '',
      prbEditor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: '事業内容を入力しましょう！',
        onUpdate: ({ getJSON, getHTML }) => {
          this.prbDescription = getHTML().replace(/<p><\/p>/g, '<p><br></p>')
        }
      }),
      prbAttachment: {
        isUpload: false,
        isComplete: false,
        isError: false,
        name: undefined,
        id: undefined
      },
      tmpDescription: '',
      tmpEditor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: '提案の形式を埋めてください。',
        onUpdate: ({ getJSON, getHTML }) => {
          this.tmpDescription = getHTML().replace(/<p><\/p>/g, '<p><br></p>')
        }
      }),
      tmpAttachment: {
        isUpload: false,
        isComplete: false,
        isError: false,
        name: undefined,
        id: undefined,
        fileType: undefined
      },
      questionnaire: [
        {
          title: '',
          type: 1,
          options: [ '' ]
        }
      ],
      questionnaireOptions: [
        { value: 1, text: 'ラジオボタン' },
        { value: 2, text: 'チェックボックス' },
        { value: 3, text: 'プルダウン' },
        { value: 4, text: '記述式' }
      ],
      questionnaireIcon: {
        1: ['far', 'circle'],
        2: ['far', 'square']
      },
      questionnaireTemp: {
        title: '',
        type: 1,
        options: [ '' ]
      },
      criteria: {
        '0': ['', '', '', '', ''],
        '1': ['独創性', '実現性', '成長性', '事業収益性', '熱意'],
        '2': ['独創性', '実現性', '成長性', '事業収益性', '熱意'],
        '3': ['独創性', '実現性', '成長性', '事業収益性', '熱意']
      },
      graders: '',
      awards: {
        limitCase: '',
        prize: '',
        limitDate: null,
        phase2: { title: '', detail: '' },
        ceremony: ''
      },
      limitDateOptions: [
        { value: null, text: '選択してください' },
        { value: 1, text: '1ヶ月後まで' },
        { value: 2, text: '2ヶ月後まで' },
        { value: 3, text: '3ヶ月後まで' }
      ],
      awardsOptions: [
        { value: 0, text: 'なし' },
        { value: 1, text: 'コラボオファー' },
        { value: 2, text: 'インターンオファー' },
        { value: 3, text: '採用オファー' }
      ],
      isModal: false,
      modalInfo: {}
    }
  },
  methods: {
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-light', 'text-primary']
      } else {
        return ['bg-light']
      }
    },
    onCopy () {
      this.isCopied = true
    },
    removeCover () {
      let smartthon = this.smartthon
      smartthon.isCover = false
      this.$store.commit('onSmartthonStateChanged', smartthon)
    },
    getDropzoneData (data) {
      switch (data.type) {
        case 'cover':
          this.isUpload = data.isUpload
          this.coverId = data.coverId
          break
        case 'biz':
          this.bizAttachment.isUpload = (data.isUpload ? data.isUpload : false)
          this.bizAttachment.isComplete = (data.isComplete ? data.isComplete : false)
          this.bizAttachment.isError = (data.isError ? data.isError : false)
          this.bizAttachment.name = data.name
          if (!data.isError) data.name = 'エラーが発生しました。時間を置いてお試しください。'
          break
        case 'prb':
          this.prbAttachment.isUpload = (data.isUpload ? data.isUpload : false)
          this.prbAttachment.isComplete = (data.isComplete ? data.isComplete : false)
          this.prbAttachment.isError = (data.isError ? data.isError : false)
          this.prbAttachment.name = data.name
          if (!data.isError) data.name = 'エラーが発生しました。時間を置いてお試しください。'
          break
        case 'tmp':
          this.tmpAttachment.isUpload = (data.isUpload ? data.isUpload : false)
          this.tmpAttachment.isComplete = (data.isComplete ? data.isComplete : false)
          this.tmpAttachment.isError = (data.isError ? data.isError : false)
          this.tmpAttachment.name = data.name
          if (!data.isError) data.name = 'エラーが発生しました。時間を置いてお試しください。'
          break
      }
    },
    setBody () {
      return {
        title: (this.titleState ? this.title['0'] : undefined),
        coverId: (this.coverState ? this.coverId || this.smartthon.coverId : undefined),
        biz: {
          title: (this.bizTitleState ? this.bizTitle['0'] : undefined),
          description: (this.bizDescriptionState ? this.bizDescription : undefined),
          attachmentName: this.bizAttachment.name || undefined
        },
        problem: {
          description: (this.prbDescriptionState ? this.prbDescription : undefined),
          attachmentName: this.prbAttachment.name || undefined
        },
        suggestion: {
          description: (this.tmpDescriptionState ? this.tmpDescription : undefined),
          attachmentName: this.tmpAttachment.name || undefined,
          questionnaire: (this.questionnaire.length ? this.questionnaire : undefined)
        },
        grading: {
          criteria: (this.criteriaState ? this.criteria['0'] : undefined),
          graders: (this.gradersState ? Number(this.graders) : undefined)
        },
        awards: {
          limitCase: (this.limitCaseState ? Number(this.awards.limitCase) : undefined),
          prize: (this.prizeState ? Number(this.awards.prize) : undefined),
          limitDate: this.awards.limitDate || undefined,
          phase2: {
            type: this.awards.phase2.type,
            title: (this.phase2TitleState ? this.awards.phase2.title : undefined),
            detail: (this.awards.phase2.detail ? this.awards.phase2.detail : undefined)
          },
          ceremony: (this.ceremonyState ? this.awards.ceremony : undefined)
        }
      }
    },
    updateDraft () {
      this.updating.draft = true

      let pathParams = {
        smartthonId: this.$route.params.smartthonId
      }

      let additionalParams = {
        queryParams: {
          type: 'update'
        }
      }

      let body = this.setBody()

      this.$apig.patch(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, body)
        .then(response => {
          // 成功のアラート
          if (this.smartthon.status === '1') this.modalInfo.title = '下書きを保存しました！'
          else this.modalInfo.title = '保存しました！'
          this.isModal = true
          this.updating.draft = false
        })
        .catch(err => {
          // 失敗のアラート
          this.alert.dismissCountDown = this.alert.dismissSecs
          this.alert.message = err.response.data.message
          this.alert.variant = 'danger'
          this.updating.draft = false
        })
    },
    publish () {
      if (!this.publishState) {
        this.alert.dismissCountDown = this.alert.dismissSecs
        this.alert.message = '必須項目を入力してください'
        this.alert.variant = 'danger'
        return
      }

      this.updating.publish = true

      let pathParams = {
        smartthonId: this.$route.params.smartthonId
      }

      let additionalParams = {
        queryParams: {
          type: 'publish'
        }
      }

      let body = this.setBody()

      this.$apig.patch(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, body)
        .then(response => {
          this.smartthon.status.isApplication = true
          this.$store.commit('onSmartthonStateChanged', this.smartthon)
          this.modalInfo.title = '一般公開を申請しました！'
          this.isModal = true
          this.updating.publish = false
        })
        .catch(err => {
          // 失敗のアラート
          this.alert.dismissCountDown = this.alert.dismissSecs
          this.alert.message = err.response.data.message
          this.alert.variant = 'danger'
          this.updating.publish = false
        })
    },
    countDownChanged (dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown
    },
    addQuestionnaire () {
      this.questionnaire.push({
        title: '',
        type: 1,
        options: [ '' ]
      })
    }
  },
  mounted () {
    let pathParams = {
      smartthonId: this.$route.params.smartthonId
    }

    let additionalParams = {
      queryParams: {
        enterpriseId: this.user.enterpriseId,
        type: 'edit'
      }
    }

    this.$apig.get(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, {})
      .then(response => {
        let smartthon = response.data
        if (response.data.coverId) {
          smartthon.isCover = true
          smartthon.cover = `${process.env.S3}/smartthon/${this.$route.params.smartthonId}/cover/${smartthon.coverId}.png`
        }
        this.$store.commit('onSmartthonStateChanged', smartthon)

        this.title['0'] = response.data.title || ''

        if (response.data.biz) {
          this.bizTitle['0'] = response.data.biz.title || ''
          if (response.data.biz.description) {
            this.bizDescription = response.data.biz.description
            this.bizEditor.setContent(response.data.biz.description.replace(/<p><br><\/p>/g, '<p></p>'))
          }
          this.bizAttachment.name = response.data.biz.attachmentName
        }

        if (response.data.problem) {
          this.prbAttachment.name = response.data.problem.attachmentName
          if (response.data.problem.description) {
            this.prbDescription = response.data.problem.description
            this.prbEditor.setContent(response.data.problem.description.replace(/<p><br><\/p>/g, '<p></p>'))
          }
        }

        if (response.data.suggestion) {
          this.tmpAttachment.name = response.data.suggestion.attachmentName
          if (response.data.suggestion.description) {
            this.tmpDescription = response.data.suggestion.description
            this.tmpEditor.setContent(response.data.suggestion.description.replace(/<p><br><\/p>/g, '<p></p>'))
          }
          if (response.data.suggestion.questionnaire) this.questionnaire = response.data.suggestion.questionnaire
        }

        if (response.data.grading) {
          if (response.data.grading.criteria) this.criteria['0'] = response.data.grading.criteria
          if (response.data.grading.graders) this.graders = response.data.grading.graders
        }

        if (response.data.awards) {
          if (response.data.awards.limitCase) this.awards.limitCase = response.data.awards.limitCase
          if (response.data.awards.prize) this.awards.prize = response.data.awards.prize
          if (response.data.awards.limitDate) this.awards.limitDate = response.data.awards.limitDate
          if (response.data.awards.ceremony) this.awards.ceremony = response.data.awards.ceremony
          if (response.data.awards.phase2 && response.data.awards.phase2.type) this.awards.phase2.type = response.data.awards.phase2.type
          if (response.data.awards.phase2 && response.data.awards.phase2.title) this.awards.phase2.title = response.data.awards.phase2.title
          if (response.data.awards.phase2 && response.data.awards.phase2.detail) this.awards.phase2.detail = response.data.awards.phase2.detail
        }

        this.loading = false
      })
      .catch(err => {
        console.log(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/edit/edit.js